export default "__VITE_ASSET__d2fb250f__"